import { createStore, applyMiddleware} from 'redux'
import thunk from 'redux-thunk'
import rootReducer from '../reducers'
import { composeWithDevTools } from 'redux-devtools-extension';
// import { currentUser } from '../actions/auth.action';

const initialState ={}

const middleware = [thunk]

const store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(...middleware)));

// store.dispatch(currentUser());

// coonsole.log(store.getState());
export default store;

